import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskProposedUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskProposedUI;